export const registerHotkeysAction = async (hotkeys: { [key: string]: string }) => {
    if (!window.electronApi) {
        return;
    }

    window.electronApi.registerShortcuts(hotkeys);
};
